import React from "react";

import "./notLoggedInView.m.css";

const NotLoggedInView = () => (
  <div styleName="not-logged-view">
    <div styleName="description">Please click on login</div>
  </div>
);

export default NotLoggedInView;
